import { ServiceRegistry } from '../../../../core/ServiceRegistry';

/**
 * True while a server room is connected — the server then owns every player's
 * HP (the HUD draws the server's value), so a client-side write to
 * `player.health` is a heal that never happened. Offline (no room: the
 * ability lab, local sims) the client's copy is the only HP there is, the same
 * split DamageBridge's offline aura heal makes. Plan 21 B25.
 */
export function serverOwnsHealth(): boolean {
  try {
    if (ServiceRegistry.getInstance().get('NetworkManager', { optional: true })?.getRoom?.()) return true;
  } catch {
    // Registry not ready — fall through to the global handle.
  }
  return Boolean((globalThis as { nm?: { getRoom?: () => unknown } }).nm?.getRoom?.());
}
